import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PopupLeadForm({ onClose, onSubmitted }) {
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [purity, setPurity] = useState("");
    const [gram, setGram] = useState("");
    const [source, setSource] = useState("");
  const [loading, setLoading] = useState(false);
const [popupFormTouched, setPopupFormTouched] = useState(false);
const location = useLocation();

    const [errors, setErrors] = useState({
        name: "",
        phoneNumber: "",
        purity: "",
        gram: "",
        source: "",
    });

    const [isBlocked, setIsBlocked] = useState(false);

useEffect(() => {
    setName("");
    setPhoneNumber("");
    setPurity("");
    setGram("");
    setSource("");
    setLoading(false);
    setPopupFormTouched(false);


    setErrors({
        name: "",
        phoneNumber: "",
        purity: "",
        gram: "",
        source: "",
    });
}, [location.pathname]);

    const sanitizeName = (value) => {
    return value
        .replace(/[^A-Za-z\s]/g, "")
        .replace(/\s{2,}/g, " ")
        .replace(/^\s+/, "")
        .slice(0, 50);
};

    const validateName = (value) => {
    const cleanValue = value.trim();

    if (!cleanValue) return "Name is required";
    if (cleanValue.length < 2) return "Enter valid name";
    if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(cleanValue)) {
        return "Name can contain only letters and spaces";
    }

    return "";
};

    const validatePhoneNumber = (value) => {
        if (!value.trim()) return "Phone number is required";
        if (!/^\d{10}$/.test(value)) return "Phone number must be 10 digits";
        return "";
    };

const validatePurity = (value) => {
    return "";
};

const validateGram = (value) => {
    if (!value.toString().trim()) return "";

    if (isNaN(value)) return "Gram must be a number";
    if (Number(value) <= 0) return "Gram must be greater than 0";

    return "";
};

const validateSource = (value) => {
    if (!value.trim()) return "Requirement is required";
    return "";
};

    const validateForm = () => {
        const newErrors = {
            name: validateName(name),
            phoneNumber: validatePhoneNumber(phoneNumber),
            purity: validatePurity(purity),
            gram: validateGram(gram),
            source: validateSource(source),
        };

        setErrors(newErrors);

       return (
    !newErrors.name &&
    !newErrors.phoneNumber &&
    !newErrors.source
);
    };
const isFormValid =
    name.trim() !== "" &&
    phoneNumber.trim() !== "" &&
    source.trim() !== "" &&
    !validateName(name) &&
    !validatePhoneNumber(phoneNumber) &&
    !validateSource(source);

  const canSubmitPopupForm = popupFormTouched && isFormValid && !loading;

const handleSubmit = async (e) => {
    e.preventDefault();
if (loading) return;

if (!popupFormTouched || !isFormValid) {
    validateForm();
    return;
}

    setLoading(true);

    const payload = {
        name: name.trim(),
        phoneNumber: phoneNumber.trim(),
        purity,
        gram: gram.toString().trim(),
        source,
        pageUrl: window.location.href,
    };

    try {
        await fetch(
        
            "https://script.google.com/macros/s/AKfycbzsm9GpSFkpXhXIdCAwkrxmvZiCwocLluAz3qFQ1QQ3vSFP3DATlZZfk4MieBCcN5LI/exec",
            {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "text/plain;charset=utf-8",
                },
                body: JSON.stringify(payload),
            }
        );

        alert("Submitted Successfully");

        setName("");
        setPhoneNumber("");
        setPurity("");
        setGram("");
        setSource("");
        setPopupFormTouched(false);
        setErrors({
            name: "",
            phoneNumber: "",
            purity: "",
            gram: "",
            source: "",
        });

        setIsBlocked(true);
        onSubmitted?.();
        onClose?.();
    } catch (err) {
        console.error("Submit error:", err);
        alert("Submission failed");
    } finally {
        setLoading(false);
    }
};

    if (isBlocked) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-4">
            <div className="relative w-full max-w-[420px] rounded-[24px] bg-white shadow-[0_18px_60px_rgba(0,0,0,0.24)] border border-[#f3e7cd]">
              <button
  type="button"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose?.();
  }}
  className="absolute right-4 top-4 z-20 flex h-9 w-9 items-center justify-center rounded-full text-xl text-[#7a5a14] transition hover:bg-[#fff7e8]"
  aria-label="Close popup"
>
  ✕
</button>

                <div className="px-6 py-7 sm:px-7 sm:py-8">
                    <h2 className="pr-10 text-[2rem] font-bold leading-tight text-[#1f2937]">
                        Get the Best Value for Your Gold
                    </h2>

                 <form
  onSubmit={handleSubmit}
  className="mt-6 flex flex-col gap-4"
  autoComplete="off"
>
                        <div>
                          <label className="mb-1.5 block text-sm font-semibold text-[#374151]">
    Name <span className="text-red-500">*</span>
</label>
                            <input
                                placeholder="Enter your name"
                                value={name}
                                autoComplete="new-password"
                                onChange={(e) => {
    const value = sanitizeName(e.target.value);
setPopupFormTouched(true);
    setName(value);
    setErrors((prev) => ({
        ...prev,
        name: validateName(value),
    }));
}}
                                className="h-12 w-full rounded-[16px] border border-[#e5e7eb] bg-[#fafafa] px-4 text-[15px] text-[#111827] outline-none transition focus:border-[#d4a93a] focus:bg-white focus:ring-2 focus:ring-[#f4e2a8]"
                                required
                            />
                            {errors.name && (
                                <p className="mt-1.5 text-sm text-red-500">{errors.name}</p>
                            )}
                        </div>

                        <div>
                        <label className="mb-1.5 block text-sm font-semibold text-[#374151]">
    Phone Number <span className="text-red-500">*</span>
</label>
                            <input
                                placeholder="Enter 10 digit phone number"
                                value={phoneNumber}
                                autoComplete="new-password"
                                onChange={(e) => {
                                    setPopupFormTouched(true);
                                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    setPhoneNumber(value);
                                    setErrors((prev) => ({
                                        ...prev,
                                        phoneNumber: validatePhoneNumber(value),
                                    }));
                                }}
                                className="h-12 w-full rounded-[16px] border border-[#e5e7eb] bg-[#fafafa] px-4 text-[15px] text-[#111827] outline-none transition focus:border-[#d4a93a] focus:bg-white focus:ring-2 focus:ring-[#f4e2a8]"
                                required
                            />
                            {errors.phoneNumber && (
                                <p className="mt-1.5 text-sm text-red-500">{errors.phoneNumber}</p>
                            )}
                        </div>

                        <div>
                          <label className="mb-1.5 block text-sm font-semibold text-[#374151]">
    Requirements <span className="text-red-500">*</span>
</label>
                            <select
                                value={source}
                                 autoComplete="new-password"
                                onChange={(e) => {
                                    setPopupFormTouched(true);
                                    setSource(e.target.value);
                                    setErrors((prev) => ({
                                        ...prev,
                                        source: validateSource(e.target.value),
                                    }));
                                }}
                                className="h-12 w-full rounded-[16px] border border-[#e5e7eb] bg-[#fafafa] px-4 text-[15px] text-[#111827] outline-none transition focus:border-[#d4a93a] focus:bg-white focus:ring-2 focus:ring-[#f4e2a8]"
                                
                            >
                                <option value="">Select Requirements</option>
<option value="Sell Gold for Cash">Sell Gold for Cash</option>
<option value="Release Pledged Gold">Release Pledged Gold</option>
<option value="Sell Gold from Home">Sell Gold from Home</option>
<option value="Get Stone Value in Gold">Get Stone Value in Gold</option>
<option value="Sell Old Gold Jewellery">Sell Old Gold Jewellery</option>
<option value="Jewellery Valuation">Jewellery Valuation</option>

                            </select>
                            {errors.source && (
                                <p className="mt-1.5 text-sm text-red-500">{errors.source}</p>
                            )}
                        </div>
                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-[#374151]">
                                Gold Purity
                            </label>
                            <select
                                value={purity}
                                autoComplete="new-password"
                                onChange={(e) => {
                                    setPopupFormTouched(true);
                                    setPurity(e.target.value);
                                    setErrors((prev) => ({
                                        ...prev,
                                        purity: validatePurity(e.target.value),
                                    }));
                                }}
                                className="h-12 w-full rounded-[16px] border border-[#e5e7eb] bg-[#fafafa] px-4 text-[15px] text-[#111827] outline-none transition focus:border-[#d4a93a] focus:bg-white focus:ring-2 focus:ring-[#f4e2a8]"
                                
                            >
                               
                                <option value="18K">18K</option>
                                <option value="20K">20K</option>
                                <option value="22K">22K</option>
                                <option value="24K">24K</option>
                            </select>
                            {errors.purity && (
                                <p className="mt-1.5 text-sm text-red-500">{errors.purity}</p>
                            )}
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-[#374151]">
                                Weight in Gram
                            </label>
                            <input
  placeholder="Enter gold weight"
  value={gram}
  autoComplete="new-password"
  maxLength={4}
                                onChange={(e) => {
                                    setPopupFormTouched(true);
     const value = e.target.value
  .replace(/[^0-9.]/g, "")
  .slice(0, 4);
                                    setGram(value);
                                    setErrors((prev) => ({
                                        ...prev,
                                        gram: validateGram(value),
                                    }));
                                }}
                                className="h-12 w-full rounded-[16px] border border-[#e5e7eb] bg-[#fafafa] px-4 text-[15px] text-[#111827] outline-none transition focus:border-[#d4a93a] focus:bg-white focus:ring-2 focus:ring-[#f4e2a8]"
                                
                            />
                            {errors.gram && (
                                <p className="mt-1.5 text-sm text-red-500">{errors.gram}</p>
                            )}
                        </div>


                        <button
                            type="submit"
disabled={!canSubmitPopupForm}
                            className="mt-2 h-12 rounded-[16px] bg-gradient-to-r from-[#b67b1d] via-[#c9932e] to-[#e0b24a] text-base font-semibold text-white shadow-[0_10px_25px_rgba(201,147,46,0.24)] transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-60"
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}